var render = function render(){var _vm=this,_c=_vm._self._c;return _c('type-template',{attrs:{"gender":_vm.gender,"first-spots-occurrence":_vm.firstSpotsOccurrence,"spot-occurrence-values":_vm.spotOccurrenceValues,"facial-spot-locations":_vm.facialSpotLocations,"field-errors":_vm.fieldErrors},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }